var staticDayTime = 86400000

module.exports = staticDayTime



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/staticDayTime.js
// module id = 2MQH
// module chunks = 4